$('.js-expandable-pill').on('click', function () {
  var t = $(this)
  if (t.hasClass('js-active')) {
    closePill(t)
  } else {
    openPill(t)
  }
})

var transitionSpeed = 200

function openPill (pillEl) {
  var label = pillEl.find('.js-pill-label')
  var info = pillEl.find('.js-pill-info')
  label.animate({
    'width': '0'
  }, transitionSpeed, function () {
    info.animateAuto('width', transitionSpeed, function () {
      $(document).on('click', closePill)
    })
  })
  pillEl.addClass('js-active')
}

function closePill (pillEl) {
  pillEl = pillEl.length ? pillEl : $('.js-expandable-pill.js-active')
  if (pillEl.length) {
    var label = pillEl.find('.js-pill-label')
    var info = pillEl.find('.js-pill-info')
    info.animate({
      'width': '0'
    }, transitionSpeed, function () {
      label.animateAuto('width', transitionSpeed, function () {
        $(document).off('click')
      })
    })
    pillEl.removeClass('js-active')
  }
}


// Extends jQuery to allow for animating to height/width auto
jQuery.fn.animateAuto = function(prop, speed, callback){
  var elem, height, width;
  return this.each(function(i, el){
    el = jQuery(el), elem = el.clone().css({ 'height': 'auto', 'width': 'auto' }).appendTo('body')
    height = elem.css('height'),
    width = elem.css('width'),
    elem.remove()

    if(prop === 'height')
        el.animate({'height': height}, speed, callback)
    else if(prop === 'width')
        el.animate({'width': width}, speed, callback)
    else if(prop === 'both')
        el.animate({'width': width, 'height': height}, speed, callback)
  });
}
